import React, { useState } from 'react';
import Icon from '../../components/AppIcon';
import GruShell from '../../components/gru/GruShell';
import TabGru from './components/TabGru';
import TabComponenti from './components/TabComponenti';
import TabRepartiCampi from './components/TabRepartiCampi';
import TabCodifiche from './components/TabCodifiche';
import TabMagazzini from './components/TabMagazzini';

const TABS = [
  { id: 'gru',        label: 'Gru',                icona: 'Construction', Componente: TabGru },
  { id: 'componenti', label: 'Componenti',         icona: 'Cog',          Componente: TabComponenti },
  { id: 'reparti',    label: 'Reparti e campi',    icona: 'Layers',       Componente: TabRepartiCampi },
  { id: 'codifiche',  label: 'Cause e codifiche',  icona: 'ListChecks',   Componente: TabCodifiche },
  { id: 'magazzini',  label: 'Magazzini',          icona: 'Warehouse',    Componente: TabMagazzini },
];

// /gru-configurazione — gestione di gru, componenti, reparti/campi, codifiche e magazzini
const GruConfigurazionePage = () => {
  const [tabAttivo, setTabAttivo] = useState('gru');
  const corrente = TABS.find((t) => t.id === tabAttivo) ?? TABS[0];
  const Contenuto = corrente.Componente;

  return (
    <GruShell indietroA="/gru-inventory">
      <div className="w-full animate-in fade-in slide-in-from-bottom-6 duration-700 ease-out">
        {/* Intestazione */}
        <div className="mb-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-[2px] bg-primary rounded-full" />
            <span className="text-[10px] font-black uppercase tracking-[0.5em] text-muted-foreground/50">
              Sistema di Gestione Carriponti
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black tracking-[-0.06em] uppercase leading-none text-foreground">
            CONFIGURA<span className="text-primary">ZIONE</span>
          </h2>
        </div>

        {/* Tab bar */}
        <div className="flex overflow-x-auto border-b border-border/40 mb-8" style={{ scrollbarWidth: 'none' }}>
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTabAttivo(t.id)}
              className={`flex items-center justify-center gap-2 py-3 px-4 md:px-6 text-[10px] font-black uppercase tracking-widest rounded-t-xl transition-all duration-200 border-b-2 whitespace-nowrap ${
                tabAttivo === t.id
                  ? 'text-primary border-primary bg-primary/5'
                  : 'text-muted-foreground/50 border-transparent hover:text-muted-foreground'
              }`}
            >
              <Icon name={t.icona} size={12} />
              {t.label}
            </button>
          ))}
        </div>

        {/* Il tab attivo viene montato solo quando serve e ricarica i propri dati */}
        <Contenuto key={corrente.id} />
      </div>
    </GruShell>
  );
};

export default GruConfigurazionePage;
